// removed by extract-text-webpack-plugin
module.exports = {"wasabi-nav-container":"wasabi-nav-container","tabsection":"tabsection","checkedsection":"checkedsection","wasabi-nav-tabs":"wasabi-nav-tabs","tabmenu":"tabmenu","close":"close","tabhome":"tabhome","active":"active","tabuser":"tabuser","tabuser-control":"tabuser-control","left":"left","right":"right","content":"content","text":"text","icon":"icon","closeicon":"closeicon","split":"split"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Navigation/MenuTabs.scss
// module id = 259
// module chunks = 0